
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { 
  Users, 
  Wallet, 
  Package, 
  TrendingUp,
  ChevronUp,
  ChevronDown
} from "lucide-react";

export const OverviewMetrics = () => {
  // Mock data - in a real app, this would come from an API
  const metrics = [
    {
      title: "Total Bubbles",
      value: "1,472",
      change: "+12%",
      increasing: true,
      icon: Package,
      color: "text-blue-500",
      bgColor: "bg-blue-100"
    },
    {
      title: "Total Users",
      value: "3,642",
      change: "+24%",
      increasing: true,
      icon: Users,
      color: "text-green-500",
      bgColor: "bg-green-100"
    },
    {
      title: "Wallet Balance",
      value: "$246,389",
      change: "+18%",
      increasing: true,
      icon: Wallet,
      color: "text-amber-500",
      bgColor: "bg-amber-100"
    },
    {
      title: "Growth Rate",
      value: "32%",
      change: "-3%",
      increasing: false,
      icon: TrendingUp,
      color: "text-purple-500",
      bgColor: "bg-purple-100"
    }
  ];

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      {metrics.map((metric, index) => (
        <Card key={index}>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">{metric.title}</p>
                <h3 className="mt-1 text-2xl font-bold">{metric.value}</h3>
                <div className="mt-1 flex items-center gap-1">
                  {metric.increasing ? (
                    <ChevronUp className="h-4 w-4 text-green-500" />
                  ) : (
                    <ChevronDown className="h-4 w-4 text-red-500" />
                  )}
                  <span className={metric.increasing ? "text-green-500" : "text-red-500"}>
                    {metric.change}
                  </span>
                  <span className="text-xs text-muted-foreground">from last month</span>
                </div>
              </div>
              <div className={`rounded-full p-2 ${metric.bgColor}`}>
                <metric.icon className={`h-6 w-6 ${metric.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
